export const getBackgroundImage = ({ desktopImage, mobileImage }: any) =>
  window.innerWidth < 600 && mobileImage ? mobileImage : desktopImage;
